import { createContext } from 'react';
import { Category } from '../../models';

export interface CategoryContextValue {
  data: Category[];
  working: boolean;
}

export const CategoryContext = createContext<CategoryContextValue>({ data: [], working: false });
